module.exports = __webpack_public_path__ + "img/icon_change.5661a13e.svg";